// extracted by mini-css-extract-plugin
module.exports = {"player":"_8T23w","closeButton":"za3Ha","video":"V0H0Q","theme_small":"_9hYjl"};